import { APIModel, APIModelImpl } from '../uicomponentapimodel';
import { CategoryDtoImpl } from '../../../core/dto/categories/categorydto';
import { CategoriesResponse } from '../../../core/api/categories/categoriesresponse';
import { CategoriesRequestImpl } from '../../../core/api/categories/categoriesrequest';

export interface ToolbarAPIModel extends APIModel
{
    getCategories(): void;
}

export class ToolbarAPIModelImpl extends APIModelImpl implements ToolbarAPIModel
{
     getCategories(): void 
     {
        let categoryDto = new CategoryDtoImpl();
        categoryDto.setLanguage(this.getContext().getUserContext().getLanguage());
        
        this.getAPIProcesssorFactory().getCategoriesAPIProcessorFactory().getCategories()
                   .success((categoriesResponse : CategoriesResponse)=>
                    {
                        this.getAPIModelHandler().onSuccess(categoriesResponse.getAPIFeature(), 
                        categoriesResponse.getDescription(), categoriesResponse.getCategoriesList()); 
                    })
                  .failure((categoriesResponse : CategoriesResponse)=>
                  {
                      this.getAPIModelHandler().onFailure(categoriesResponse.getAPIFeature(), 
                      categoriesResponse.getDescription(), categoriesResponse);
                    })
                  .execute(new CategoriesRequestImpl(categoryDto));
     }
}


 


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/toolkit/toolbar/toolbarapimodel.tsx